// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.basket-overlay[data-v-090c945e]{border:1px solid var(--c-light-gray);left:auto;position:absolute;right:0;top:45px;transition:none;width:390px}.basket-overlay__sticky-desktop[data-v-090c945e]{left:auto;position:fixed;right:24px;top:0}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
